"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUser = function (signedInUser) {
    return {
        type: 'UPDATE_USER',
        name: signedInUser.name,
        handle: signedInUser.handle,
        avatarUrl: signedInUser.avatarUrl,
    };
};
exports.defaultUser = {
    language: 'en',
};
exports.user = function (state, action) {
    if (state === void 0) { state = exports.defaultUser; }
    switch (action.type) {
        case 'UPDATE_USER':
            return __assign(__assign({}, state), { name: action.name, handle: action.handle, avatarUrl: action.avatarUrl });
        case 'UPDATE_LANGUAGE':
            return __assign(__assign({}, state), { language: action.language });
        default:
            return state;
    }
};
